function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../../locales/keys';
import { i18n } from 'invision-core';
import { CurrentCustomerIdSelector } from '../../../reducers/selectors/customer.selectors';
import { ConvergentBillerSubscriberSummaryServicesSelector } from '../../../reducers/selectors/customer.convergent.biller.selectors';
import { IsExecutingBillRunSelector } from '../../../reducers/selectors/demoActions.selectors';
import { executeBillRun } from '../../../reducers/actions/demoActions.actions';
import { NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
var DemoActionsController = /*#__PURE__*/function () {
  function DemoActionsController($ngRedux, uiNotificationService) {
    _classCallCheck(this, DemoActionsController);
    this.disconnectRedux = null;
    this.mapStateToTarget = function (store) {
      return {
        currentCustomerId: CurrentCustomerIdSelector(store),
        isExecutingBillRun: IsExecutingBillRunSelector(store)
      };
    };
    this.controllerActions = {
      executeBillRun: executeBillRun
    };
    this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
    this.uiNotificationService = uiNotificationService;
    this.$ngRedux = $ngRedux;
  }
  return _createClass(DemoActionsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.disconnectRedux = this.$ngRedux.connect(this.mapStateToTarget, this.controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
    //need
  }, {
    key: "shouldShowLoading",
    value: function shouldShowLoading() {
      return this.state.isExecutingBillRun;
    }
  }, {
    key: "executeBillRunOnClick",
    value: function executeBillRunOnClick() {
      var _this2 = this;
      this.actions.executeBillRun(this.state.currentCustomerId).then(function () {
        _this2.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.DEMO_ACTIONS.EXECUTE_BILL_RUN_SUCCESS), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      }).catch(function () {
        _this2.uiNotificationService.error(i18n.translate(CustomerCareLocaleKeys.DEMO_ACTIONS.EXECUTE_BILL_RUN_FAILURE), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      });
    }
  }]);
}();
export default {
  template: require('./demoActions.html'),
  controller: DemoActionsController,
  controllerAs: 'DemoActionsController'
};